import type { SavedTargetAccumulator } from '@/domain/WorkspaceForex/savedProducts/targetAccumulator/SavedTargetAccumulator.ts';
import type { FxTargetAccumulator, HedgeType } from '@/store/targetAccumulator/state.ts';
import { generateEmptyTargetAccumulator } from '@/store/targetAccumulator/utils.ts';

export function mapToTargetAccumulator({ properties, clientId }: SavedTargetAccumulator): FxTargetAccumulator {
  return generateEmptyTargetAccumulator(
    {
      currencyPair: properties.currencyPair,
      notional: properties.notional ?? null,
      notionalCurrencyIndex: properties.notionalCurrencyIndex,
      premiumDate: properties.premiumDate,
      cutOffMarketPlace: properties.cutOffMarketPlace,
      deliveryDate: properties.deliveryDate,
      expiryDate: properties.expiryDate,
      marginCurrency: properties.marginCurrency,
      amountMode: properties.amountMode,
      clientsWay: properties.clientsWay ?? 'Buy',
      leverage: properties.leverage,
      leverageAmount: properties.leverageAmount,
      accuType: properties.accuType,
      targetProfitType: properties.targetProfitType,
      target: properties.target,
      strike: properties.strike,
      pivot: properties.pivot,
      strikeDown: properties.strikeDown,
      strikeUp: properties.strikeUp,
      ekiTrigger: properties.ekiTrigger,
      ekiDown: properties.ekiDown,
      ekiUp: properties.ekiUp,
      firstFixingDate: properties.firstFixingDate,
      lastFixingDate: properties.lastFixingDate,
      numberOfFixings: properties.numberOfFixings,
      numberOfSettlements: properties.numberOfSettlements,
      markupCurrency: properties.markupCurrency,
      fixingFrequency: properties.fixingFrequency,
      settlementFrequency: properties.settlementFrequency,
      isCrossed: properties.isCrossed,
      crossCurrency: properties.crossCurrency,
      maxDate: properties.maxDate,
      hedgeType: properties.hedgeType as HedgeType,
      settlementMode: properties.settlementMode,
      cashSettlementCurrency: properties.cashSettlementCurrency,
    },
    clientId,
  );
}
